import request from '@/utils/axios'
export function get(url,query,loading=true) {
  return request({
    url: url,
    method: 'GET',
    params: query,
    loading,
  })
}
export function post(url,query,loading=true) {
  return request({
    url: url,
    method: 'post',
    data: query,
    loading,
  })
}
export function put(url,query,loading=true) {
  return request({
    url: url,
    method: 'put',
    data: query,
    loading,
  })
}
export function export_blob(url,query,loading=true) {
  return request({
    url: url,
    method: 'get',
    responseType : 'blob',
    params: query,
    loading,
  })
}
export function del(url,query,loading=true) {
  return request({
    url: url,
    method: 'delete',
    data: query,
    loading,
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js